import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import FormSelect from '@/components/form/formSelect'

const timezoneOptions = ['Pacific/Auckland', 'Australia/Sydney'] as const

// eslint-disable-next-line react-refresh/only-export-components
export const timezoneSchema = z.object({
    timezone: z.enum(timezoneOptions),
})
type TimezoneSchemaType = z.infer<typeof timezoneSchema>

interface Props {
    form: UseFormReturn<TimezoneSchemaType>
}

export default function CreateMarketTimezoneForm({ form }: Props) {
    return (
        <div className="space-y-4">
            <FormSelect
                control={form.control}
                name="timezone"
                label={<>Timezone</>}
                placeholder="Timezone"
                options={timezoneOptions.map(tz => ({ value: tz, label: tz }))}
            />
        </div>
    )
}
